<template>
  <div id="Hero">
    <ImageBox :item="item"></ImageBox>
  </div>
</template>

<script>
import ImageBox from './image.vue'
export default {
  props: ['item'],
  components: { ImageBox }

}
</script>

<style>
#Hero {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  width: 100%;
}
.MdImg {
  flex: 1;
  align-items: center;
  overflow: hidden;
  position: relative;
}
.MdImg span {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: center center;
}
</style>
